import { render, staticRenderFns } from "./value.vue?vue&type=template&id=cd0e78f6&scoped=true&lang=pug&"
import script from "./value.vue?vue&type=script&lang=js&"
export * from "./value.vue?vue&type=script&lang=js&"
import style0 from "./value.vue?vue&type=style&index=0&id=cd0e78f6&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd0e78f6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('cd0e78f6', component.options)
    } else {
      api.reload('cd0e78f6', component.options)
    }
    module.hot.accept("./value.vue?vue&type=template&id=cd0e78f6&scoped=true&lang=pug&", function () {
      api.rerender('cd0e78f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/floating_editor/measure/component/value.vue"
export default component.exports